module.exports = __webpack_public_path__ + "media/dice_roll-9e43a951e12153dd6812b7a2a44e7697.mp3";